import { BASE_DEV_URL } from "../env";

export const getDomainWithoutSubdomain = (url) => {
  try {
    const urlParts = new URL(url).hostname.split(".");
    return urlParts
      .slice(0)
      .slice(-(urlParts.length === 4 ? 3 : 2))
      .join(".");
  } catch {
    return "";
  }
};

export const getApiBaseUrl = () => {
  if (typeof window === "undefined") return "";
  const origin = window.location.origin.includes("localhost")
    ? BASE_DEV_URL
    : window.location.origin;
  return `${origin}/api/v1/`;
};
